const Music = () => (
  <>
    <path
      fill="currentColor"
      d="M10.058 19.808a2.9 2.9 0 0 1-2.119-.881 2.9 2.9 0 0 1-.881-2.12q0-1.236.881-2.118a2.9 2.9 0 0 1 2.119-.881q.575 0 1.091.204.516.206.909.615V5q0-.343.234-.575a.8.8 0 0 1 .581-.233h3.263q.346 0 .576.233.23.231.23.575v.923q0 .343-.232.576a.78.78 0 0 1-.576.232h-3.076v10.077q0 1.237-.881 2.119a2.9 2.9 0 0 1-2.12.88"
    />
  </>
)
export default Music
